<template lang="pug">
.building-producer(:class="info.isEnabled ? 'enabled' : 'disabled' ")
  .level {{ upgradable ? info.config.level : 'max' }}
  .costs
    .cost(v-for="(amount, item) in info.config.costs")
      Icon(:item="item" size="xs")
  .provides
    .item.flex(v-for="(amount, item) in info.config.provides")
      Icon(:item="item")
      .amount(:class="positiveOrNegative(amount)") {{ formatAmount(amount) }}

  .progress
    ProgressBar(v-if="info.buildingActive" :percent="1 - info.buildingRemaining / info.config.time" color="#0AA")
</template>

<script>
import Counter from '@/components/buildings/common/Counter'
import ProgressBar from '@/components/buildings/common/ProgressBar'

export default {
  props: [ 'info' ],
  components: { Counter, ProgressBar },
  computed: {
    upgradable () {
      return this.info.config.level < this.info.config.levelMax
    }
  },
  methods: {
    formatAmount (amount) {
      return amount > 0 ? '+' + amount : '' + amount
    },

    positiveOrNegative (amount) {
      return amount < 0 ? 'negative' : 'positive'
    }
  }
}
</script>

<style lang="scss" scoped>

.level {
  position: absolute;
  right: 4px;
  top: 0;
  line-height: 18px;
  width: 20px;
  text-align: right;
  font-size: 12px;

.costs {
  min-height: 18px;
  line-height: 18px;
  text-align: left;
  padding: 1px;
  padding-top: 2px;

  .cost {
    display: inline-block;

  }
.provides {
  height: 36px;
  display: flex;
  justify-content: center;

.building-producer {
  position: relative;
  background-color: #b8cada;
  height: 74px;

  &.disabled {
    background-color: #daddde;

    * {
      opacity: .5;

    }
  .progress {
    padding: 0;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 6px;
    width: 100%;
    border-radius: 0;


  }
  }
}
}
}
}</style>



// WEBPACK FOOTER //
// src/components/buildings/Producer.vue